import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const degreeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDegree: builder.query({
      query: ({ id }) => ({
        url: `degree/${id}`,
      }),
      providesTags: ["Degree"],
    }),
    getDegrees: builder.query({
      query: () => ({
        url: `degree?query=all`,
      }),
      providesTags: ["DegreeAll"],
    }),
    getDegreesPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `degree?${query}`,
        };
      },
      providesTags: ["Degrees"],
    }),

    addDegree: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `degree`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Degree added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Degrees", "DegreeAll"],
    }),

    deleteDegree: builder.mutation({
      query: ({ id }) => ({
        url: `degree/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Degree successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Degree", "Degrees", "DegreeAll"],
    }),

    updateDegree: builder.mutation({
      query: ({ id, values }) => ({
        url: `degree/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Degree updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Degree", "Degrees", "DegreeAll"],
    }),
  }),
});

export const {
  useGetDegreeQuery,
  useGetDegreesQuery,
  useAddDegreeMutation,
  useDeleteDegreeMutation,
  useUpdateDegreeMutation,
  useGetDegreesPaginatedQuery,
} = degreeApi;
